import useIsBrowser from 'hooks/useIsBrowser';
import { useMediaQuery } from 'react-responsive';

// Note: It is impossible to accurately determine whether the device is a hover
// device on the server side, so we always return false from this hook until
// the component has mounted in the browser.
const useIsHoverDevice = () => {
  const isBrowser = useIsBrowser();

  const isHoverDevice = useMediaQuery({
    query: '(hover: hover)',
  });

  return isBrowser && isHoverDevice;
};

export default useIsHoverDevice;
